export default __webpack_public_path__ + "static/media/majors-bg_resized.59c9701d.jpg";